import Vue from 'vue';
import Router, { RouterView } from 'vue-router';

import lkRoutes from './modules/lk/shared/router/lk.router';
import boxRoutes from './modules/box/shared/router/box';
import onlineRoutes from './modules/online/shared/router/online';
import subscriptionsRoutes from './modules/subscriptions/shared/router/subscriptions';

import AppPageNotFound from '@beautybox/ui-kit/components/pages/Errors/NotFound';

import { setAuthToken } from '@beautybox/core/utils/auth';

const errorsRoutes = [
    {
        path: '*',
        name: '404',
        meta: {
            free: true,
            layout: 'empty',
        },
        component: AppPageNotFound,
    },
];

Vue.use(Router);

const routes = [
    {
        path: '/redirect',
        component: RouterView,
        beforeEnter(to, from, next) {
            const { from: fromParam, token } = { ...to.query };
            setAuthToken(token);
            window.location.href = fromParam;
        },
    },
    ...boxRoutes,
    ...onlineRoutes,
    ...subscriptionsRoutes,
    ...errorsRoutes,
];

const router = new Router({
    mode: 'history',
    base: '/',
    routes,
});

router.beforeEach(async (to, from, next) => {
    console.log('--- router to', to);
    console.log('--- router from', from);
    document.dispatchEvent(new Event('clear-error'));
    return next();
});

export default router;
